var _defs, _g, _text, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 8 296 74",
    role: "img",
    "aria-label": "5Star - Bags, Jerkins and Trolleys",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsGold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9c96a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c8991b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c7409"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fsGoldSoft",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2dd9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfa02a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 20 v-4 a4 4 0 0 1 4-4 h14 a4 4 0 0 1 4 4 v4",
    fill: "none",
    stroke: "url(#fsGold)",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 50,
    height: 52,
    rx: 9,
    fill: "#0f1c36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 50,
    height: 52,
    rx: 9,
    fill: "none",
    stroke: "url(#fsGoldSoft)",
    strokeWidth: 1.4,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#1c2c4c",
    strokeWidth: 2,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 26,
    x2: 27,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 26,
    x2: 35,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 26,
    x2: 47,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 26,
    x2: 55,
    y2: 66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 29 a9 9 0 0 1 9-9 h4 v5 h-13 z",
    fill: "url(#fsGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 29 a9 9 0 0 0-9-9 h-4 v5 h13 z",
    fill: "url(#fsGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 63 a9 9 0 0 0 9 9 h4 v-5 h-13 z",
    fill: "url(#fsGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 63 a9 9 0 0 1-9 9 h-4 v-5 h13 z",
    fill: "url(#fsGold)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#fsGoldSoft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 34 l1 2.1 2.3.3-1.7 1.6.4 2.3-2-1.1-2 1.1.4-2.3-1.7-1.6 2.3-.3z",
    transform: "scale(0.62) translate(17 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 30 l1.15 2.4 2.65.38-1.9 1.85.45 2.62-2.35-1.24-2.35 1.24.45-2.62-1.9-1.85 2.65-.38z",
    transform: "scale(0.8) translate(9 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 34 l1 2.1 2.3.3-1.7 1.6.4 2.3-2-1.1-2 1.1.4-2.3-1.7-1.6 2.3-.3z",
    transform: "scale(0.62) translate(41 12)"
  })), /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 62,
    textAnchor: "middle",
    fontFamily: "Marcellus, 'Times New Roman', serif",
    fontSize: 30,
    fill: "url(#fsGold)"
  }, "5"), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 76,
    r: 4,
    fill: "#0f1c36",
    stroke: "url(#fsGold)",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 76,
    r: 4,
    fill: "#0f1c36",
    stroke: "url(#fsGold)",
    strokeWidth: 1.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 46,
    fontFamily: "Marcellus, 'Times New Roman', serif",
    fontSize: 34,
    letterSpacing: 1,
    fill: "#0f1c36"
  }, "5", /*#__PURE__*/React.createElement("tspan", {
    fill: "#c8991b"
  }, "STAR"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 60,
    x2: 100,
    y2: 60,
    stroke: "#c8991b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 63.5,
    fontFamily: "Jost, 'Inter', sans-serif",
    fontSize: 9,
    letterSpacing: 2.4,
    fill: "#5c5342"
  }, "BAGS"), /*#__PURE__*/React.createElement("path", {
    d: "M139 60.5 l1 2 2 .3-1.5 1.4.35 2-1.85-1-1.85 1 .35-2-1.5-1.4 2-.3z",
    fill: "#c8991b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 63.5,
    fontFamily: "Jost, 'Inter', sans-serif",
    fontSize: 9,
    letterSpacing: 2.4,
    fill: "#5c5342"
  }, "JERKINS"), /*#__PURE__*/React.createElement("path", {
    d: "M203 60.5 l1 2 2 .3-1.5 1.4.35 2-1.85-1-1.85 1 .35-2-1.5-1.4 2-.3z",
    fill: "#c8991b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 63.5,
    fontFamily: "Jost, 'Inter', sans-serif",
    fontSize: 8.6,
    letterSpacing: 2.2,
    fill: "#5c5342"
  }, "TROLLEYS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cef4b4a9efeef375bcafc3708c133f38.svg";
export { ForwardRef as ReactComponent };